export const locations = {
  home: '/',
  signIn: '/sign-in',
  loggedInRedirect: '/optimization-processes',
  optimizationProcesses: '/optimization-processes',
  drugRegistry: '/drug-registry',
  optimizationProcess: (optimizationProcessId: number) =>
    `/optimization-processes/${optimizationProcessId}`,
  optimizationProcessDetails: (optimizationProcessId: number) =>
    `/optimization-processes/${optimizationProcessId}/details`,
  optimizationTasks: (
    optimizationProcessId: number,
    salesOrderId: number,
    salesOrdersLineId: number
  ) =>
    `/optimization-processes/${optimizationProcessId}/sales-orders/${salesOrderId}/lines/${salesOrdersLineId}/tasks`,
  settings: '/settings',
  workCenters: '/work-centers',
  workCenter: (workCenterId: number) => `/work-centers/${workCenterId}`,
}
